/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface DiscreteNumericListDto
 */
export interface DiscreteNumericListDto {
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscreteNumericListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof DiscreteNumericListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    numericId?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericListDto
     */
    selectedValues?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscreteNumericListDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof DiscreteNumericListDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof DiscreteNumericListDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof DiscreteNumericListDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof DiscreteNumericListDto
     */
    $type?: DiscreteNumericListDtoTypeEnum;
}


/**
 * @export
 */
export const DiscreteNumericListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.DiscreteNumericListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DiscreteNumericListDtoTypeEnum = typeof DiscreteNumericListDtoTypeEnum[keyof typeof DiscreteNumericListDtoTypeEnum];



/**
 * Check if a given object implements the DiscreteNumericListDto interface.
 */
export function instanceOfDiscreteNumericListDto(value?: unknown): value is DiscreteNumericListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DiscreteNumericListDtoTypeEnum)[0];
}

export function DiscreteNumericListDtoFromJSON(json: any): DiscreteNumericListDto {
    return DiscreteNumericListDtoFromJSONTyped(json, false);
}

export function DiscreteNumericListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscreteNumericListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'selectedValues': json['selectedValues'] == null ? undefined : json['selectedValues'],
        'availableValues': json['availableValues'] == null ? undefined : json['availableValues'],
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DiscreteNumericListDtoToJSON(value?: DiscreteNumericListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'numericId': value['numericId'],
        'unitAbbreviation': value['unitAbbreviation'],
        'selectedValues': value['selectedValues'],
        'availableValues': value['availableValues'],
        'decimalPlaces': value['decimalPlaces'],
        'valueType': CreateDefinitionDtoValueTypeToJSON(value['valueType']),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        '$type': value['$type'],
    });
}

